import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { computed } from 'mobx';
import type { TeamResponse } from 'tm3-core/api.dtos';

class TeamsStore extends CacheStore<TeamResponse> {
  constructor() {
    super('teams');
  }

  @computed
  get Current(): TeamResponse[] {
    return this.All.filter((x) => x.isCurrent);
  }
}

export default TeamsStore;
